package com.kinoshazam.uiKit.theme

import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.Color

@Composable
actual fun SetStatusBarColor(color: Color, darkIcons: Boolean) {
    // No-op
}